import React, { useEffect, useState } from "react";
import { Row, Form } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import TabellaLista from "../Tabella/TabellaLista";
import { Add, ArrowRight } from 'iconsax-react';
import { ColumnFilter } from "../table/FilteringTable/ColumnFilter";
import MyApiClient from "../../../api-client/MyApiClient";

const STATUS_MAP = {
    ACTIVE: ['Attivo', 'success'],
    COMPLETED: ['Completato', 'success'],
    INACTIVE: ['Inattivo', 'danger'],
    INVITED: ['Invito in corso', 'info'],
};

const fmtDate = (d) => {
    if (!d) return '-';
    const parts = String(d).split('-'); // yyyy-MM-dd
    if (parts.length === 3) return `${parts[2]}/${parts[1]}/${parts[0]}`;
    return d;
};

const JuniorPlayer = (props) => {
    const navigate = useNavigate();

    const openDetail = (row) => {
        navigate('/struttura/junior/junior_profile/' + row.id);
    };

    const [data_json, setDataJson] = useState(null);

    const data_column = [
        {
            Header: 'Nome e cognome',
            accessor: 'name',
            Filter: ColumnFilter,
        },
        {
            Header: 'Data di nascita',
            accessor: 'birthdate',
            Filter: ColumnFilter,
        },
        {
            Header: 'Stato',
            accessor: row => (row.status ? row.status.label : ''),
            Cell: ({ row }) => {
                const s = row.original.status;
                if (!s) return null;
                return <span className={`sid-badge sid-badge--${s.variant}`}>{s.label}</span>;
            },
            disableFilters: true,
        },
        {
            Header: '',
            accessor: 'azione',
            Cell: ({ row }) => (
                <button type="button" className="btn p-1" style={{ background: 'transparent', border: 0 }}
                    onClick={() => openDetail(row.original)} aria-label="Vedi profilo">
                    <ArrowRight size={20} color="#111827" />
                </button>
            ),
            disableFilters: true,
        },
    ];

    useEffect(() => {
        if (props.profile && props.profile.idsPlay) {
            const playerData = props.profile;
            const fetchData = async () => {
                try {
                    const tokenDetailsString = sessionStorage.getItem('userDetails');
                    if (tokenDetailsString) {
                        const token = JSON.parse(tokenDetailsString).idToken;
                        const apiClient = new MyApiClient();
                        const [juniors] = await Promise.all([
                            apiClient.getJuniorsByParent(token, playerData.idsPlay.userId)
                        ]);

                        const rows = [];
                        if (juniors) {
                            juniors.forEach((element) => {
                                const [label, variant] = STATUS_MAP[element.profileStatus] || ['', 'muted'];
                                rows.push({
                                    id: element.userId,
                                    name: `${element.givenName || ''} ${element.familyName || ''}`.trim(),
                                    birthdate: fmtDate(element.birthdate),
                                    status: label ? { label, variant } : null,
                                });
                            });
                        }
                        setDataJson(rows);
                    }
                } catch (error) {
                    console.error("Error fetching data:", error);
                }
            };
            fetchData();
        }
    }, [props]);

    const parent = props.profile && props.profile.idsPlay;
    const addJuniorUrl = parent
        ? `/struttura/junior/nuovo?parentId=${parent.userId}&parentName=${encodeURIComponent(`${parent.givenName || ''} ${parent.familyName || ''}`.trim())}&playerId=${parent.userId}`
        : '/struttura/junior/nuovo';

    return (
        <Row>
            <Form>
                <TabellaLista
                    openColumn={'name'}
                    openRow={(row) => openDetail(row)}
                    cardTitle={'Junior collegati'}
                    hasSearch={false}
                    hasFilter={false}
                    hasAddMore={false}
                    headerButtons={
                        <Link to={addJuniorUrl} className="btn btn-primary">
                            <Add size={16} className="me-1" />Aggiungi Junior
                        </Link>
                    }
                    data_column={data_column}
                    data_json={data_json}
                />
            </Form>
        </Row>
    );
};

export default JuniorPlayer;
